// extracted by mini-css-extract-plugin
export var copyableItem = "_4a-0";
export var underlined = "_4a-1";